import { Link } from "react-router-dom";
import { BookOpen, Lightbulb, Megaphone, Ticket } from "lucide-react";

import { ROUTES } from "@/routes/constants/routes";

const upcoming = [
  {
    title: "Tickets de Suporte",
    description: "Acompanhe solicitações abertas pelas gestoras.",
    icon: Ticket,
  },
  {
    title: "Sugestões",
    description: "Receba ideias de melhoria enviadas pelos usuários.",
    icon: Lightbulb,
  },
  {
    title: "Novidades",
    description: "Comunique recursos e atualizações da plataforma.",
    icon: Megaphone,
  },
];

const HelpHome = () => (
  <div className="flex flex-col gap-6">
    <header>
      <h1 className="text-[22px] font-bold text-ui-primary">Central de Ajuda</h1>
      <p className="mt-1 max-w-2xl text-sm text-ui-text-muted">
        Organize o que as gestoras e os clientes encontram quando precisam de orientação.
      </p>
    </header>

    <Link
      to={ROUTES.KNOWLEDGE_BASE.LIST}
      className="group flex flex-col gap-5 rounded-3xl border border-ui-border bg-white p-6 shadow-sm transition hover:-translate-y-0.5 hover:shadow-md md:flex-row md:items-center"
    >
      <span className="inline-flex size-14 shrink-0 items-center justify-center rounded-2xl bg-lime-400 text-[#1a2b45]">
        <BookOpen size={26} />
      </span>
      <div className="min-w-0 flex-1">
        <p className="text-xs font-semibold uppercase tracking-[0.16em] text-[#5c7a12]">Disponível</p>
        <h2 className="mt-1 text-2xl font-semibold text-ui-primary">Base de Conhecimento</h2>
        <p className="mt-2 max-w-xl text-sm text-ui-text-muted">
          Crie artigos e tutoriais, publique para a gestora, para o cliente, ou para os dois.
        </p>
      </div>
      <span className="text-sm font-medium text-ui-primary">Abrir conteúdos</span>
    </Link>

    <section className="grid gap-3 md:grid-cols-3">
      {upcoming.map((item) => {
        const Icon = item.icon;
        return (
          <article key={item.title} className="rounded-2xl border border-dashed border-ui-border bg-white/70 px-5 py-5">
            <div className="flex items-center justify-between gap-3">
              <span className="inline-flex size-9 items-center justify-center rounded-xl bg-gray-100 text-ui-text-muted">
                <Icon size={18} />
              </span>
              <span className="rounded-full bg-gray-100 px-2.5 py-1 text-[11px] font-medium uppercase tracking-wide text-ui-text-muted">
                Em breve
              </span>
            </div>
            <h3 className="mt-4 text-base font-semibold text-ui-primary">{item.title}</h3>
            <p className="mt-1 text-sm text-ui-text-muted">{item.description}</p>
          </article>
        );
      })}
    </section>
  </div>
);

export default HelpHome;
